import { Component, DestroyRef, inject, OnInit, signal } from '@angular/core';
import { PageTitleService } from '../../shared/services';
import { SystemAdminService, SystemAdminStats, SystemAdminBusiness } from '../../services/system-admin/system-admin.service';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { AuthService } from '../../services/auth';
import { Router, RouterModule, RouterOutlet } from '@angular/router';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-system-admin',
  imports: [CommonModule, RouterModule, RouterOutlet],
  template: `
    <div class="flex h-full">
      <!-- Admin Sidebar Navigation -->
      <aside class="hidden w-64 shrink-0 border-r border-gray-200 bg-white dark:border-gray-800 dark:bg-white/[0.02] lg:block">
        <div class="flex h-full flex-col">
          <!-- Sidebar top spacing to align with header -->
          <div class="h-1"></div>

          <!-- Navigation -->
          <nav class="flex-1 space-y-1 overflow-y-auto px-3 py-4">
            <p class="mb-2 px-3 text-xs font-semibold uppercase tracking-wider text-gray-400 dark:text-gray-500">General</p>
            <a routerLink="/system-admin" [routerLinkActiveOptions]="{exact: true}" routerLinkActive="bg-brand-50 text-brand-700 dark:bg-brand-500/10 dark:text-brand-400"
              class="flex items-center gap-3 rounded-lg px-3 py-2.5 text-sm font-medium text-gray-700 transition hover:bg-gray-100 dark:text-gray-300 dark:hover:bg-white/[0.04]">
              <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <rect x="3" y="3" width="7" height="7"/><rect x="14" y="3" width="7" height="7"/>
                <rect x="14" y="14" width="7" height="7"/><rect x="3" y="14" width="7" height="7"/>
              </svg>
              Dashboard
            </a>
            <a routerLink="/system-admin/businesses" routerLinkActive="bg-brand-50 text-brand-700 dark:bg-brand-500/10 dark:text-brand-400"
              class="flex items-center gap-3 rounded-lg px-3 py-2.5 text-sm font-medium text-gray-700 transition hover:bg-gray-100 dark:text-gray-300 dark:hover:bg-white/[0.04]">
              <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <path d="M3 21l18 0"/><path d="M3 7v1a3 3 0 0 0 6 0v-1m0 1a3 3 0 0 0 6 0v-1m0 1a3 3 0 0 0 6 0v-1h-18l2 -4h14l2 4"/>
                <path d="M5 21l0 -10.15"/><path d="M19 21l0 -10.15"/><path d="M9 21v-4a2 2 0 0 1 2 -2h2a2 2 0 0 1 2 2v4"/>
              </svg>
              Negocios
            </a>
            <a routerLink="/system-admin/support" routerLinkActive="bg-brand-50 text-brand-700 dark:bg-brand-500/10 dark:text-brand-400"
              class="flex items-center gap-3 rounded-lg px-3 py-2.5 text-sm font-medium text-gray-700 transition hover:bg-gray-100 dark:text-gray-300 dark:hover:bg-white/[0.04]">
              <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"/>
              </svg>
              Soporte
            </a>
            <a routerLink="/system-admin/audit-log" routerLinkActive="bg-brand-50 text-brand-700 dark:bg-brand-500/10 dark:text-brand-400"
              class="flex items-center gap-3 rounded-lg px-3 py-2.5 text-sm font-medium text-gray-700 transition hover:bg-gray-100 dark:text-gray-300 dark:hover:bg-white/[0.04]">
              <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <path d="M12 20h9"/><path d="M16.5 3.5a2.121 2.121 0 0 1 3 3L7 19l-4 1 1-4L16.5 3.5z"/>
              </svg>
              Auditoría
            </a>

            <p class="mb-2 mt-6 px-3 text-xs font-semibold uppercase tracking-wider text-gray-400 dark:text-gray-500">Catálogos</p>
            <a routerLink="/system-admin/catalogs/business-types" routerLinkActive="bg-brand-50 text-brand-700 dark:bg-brand-500/10 dark:text-brand-400"
              class="flex items-center gap-3 rounded-lg px-3 py-2.5 text-sm font-medium text-gray-700 transition hover:bg-gray-100 dark:text-gray-300 dark:hover:bg-white/[0.04]">
              <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <path d="M4 7h16"/><path d="M4 12h16"/><path d="M4 17h10"/>
              </svg>
              Tipos de Negocio
            </a>
            <a routerLink="/system-admin/catalogs/countries" routerLinkActive="bg-brand-50 text-brand-700 dark:bg-brand-500/10 dark:text-brand-400"
              class="flex items-center gap-3 rounded-lg px-3 py-2.5 text-sm font-medium text-gray-700 transition hover:bg-gray-100 dark:text-gray-300 dark:hover:bg-white/[0.04]">
              <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <circle cx="12" cy="12" r="10"/><path d="M2 12h20"/><path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z"/>
              </svg>
              Países
            </a>
          </nav>
        </div>
      </aside>

      <!-- Main Content -->
      <main class="flex-1 overflow-y-auto">
        <!-- Mobile navigation -->
        <div class="border-b border-gray-200 bg-white px-4 py-3 dark:border-gray-800 dark:bg-white/[0.02] lg:hidden">
          <div class="flex gap-2 overflow-x-auto">
            <a routerLink="/system-admin" [routerLinkActiveOptions]="{exact: true}" routerLinkActive="bg-brand-50 text-brand-700 border-brand-200 dark:bg-brand-500/10 dark:text-brand-400 dark:border-brand-500/30"
              class="whitespace-nowrap rounded-lg border border-gray-200 px-3 py-1.5 text-xs font-medium text-gray-600 dark:border-gray-700 dark:text-gray-400">
              Dashboard
            </a>
            <a routerLink="/system-admin/businesses" routerLinkActive="bg-brand-50 text-brand-700 border-brand-200 dark:bg-brand-500/10 dark:text-brand-400 dark:border-brand-500/30"
              class="whitespace-nowrap rounded-lg border border-gray-200 px-3 py-1.5 text-xs font-medium text-gray-600 dark:border-gray-700 dark:text-gray-400">
              Negocios
            </a>
            <a routerLink="/system-admin/support" routerLinkActive="bg-brand-50 text-brand-700 border-brand-200 dark:bg-brand-500/10 dark:text-brand-400 dark:border-brand-500/30"
              class="whitespace-nowrap rounded-lg border border-gray-200 px-3 py-1.5 text-xs font-medium text-gray-600 dark:border-gray-700 dark:text-gray-400">
              Soporte
            </a>
            <a routerLink="/system-admin/audit-log" routerLinkActive="bg-brand-50 text-brand-700 border-brand-200 dark:bg-brand-500/10 dark:text-brand-400 dark:border-brand-500/30"
              class="whitespace-nowrap rounded-lg border border-gray-200 px-3 py-1.5 text-xs font-medium text-gray-600 dark:border-gray-700 dark:text-gray-400">
              Auditoría
            </a>
            <a routerLink="/system-admin/catalogs/business-types" routerLinkActive="bg-brand-50 text-brand-700 border-brand-200 dark:bg-brand-500/10 dark:text-brand-400 dark:border-brand-500/30"
              class="whitespace-nowrap rounded-lg border border-gray-200 px-3 py-1.5 text-xs font-medium text-gray-600 dark:border-gray-700 dark:text-gray-400">
              Tipos de Negocio
            </a>
            <a routerLink="/system-admin/catalogs/countries" routerLinkActive="bg-brand-50 text-brand-700 border-brand-200 dark:bg-brand-500/10 dark:text-brand-400 dark:border-brand-500/30"
              class="whitespace-nowrap rounded-lg border border-gray-200 px-3 py-1.5 text-xs font-medium text-gray-600 dark:border-gray-700 dark:text-gray-400">
              Países
            </a>
          </div>
        </div>

        <div class="p-5 lg:p-6">
          <router-outlet></router-outlet>
        </div>
      </main>
    </div>
  `,
  styles: [`
    :host { display: block; height: calc(100vh - 64px); }
  `],
})
export class SystemAdmin implements OnInit {
  private authService = inject(AuthService);
  private router = inject(Router);
  private titleService = inject(PageTitleService);

  ngOnInit(): void {
    if (!this.authService.isSystemAdmin()) {
      this.router.navigate(['/agendas']);
      return;
    }
    this.titleService.setPage({
      title: 'Administración del sistema',
      subtitle: 'Negocios, catálogos y actividad de la plataforma',
    });
  }
}
